import { z } from "zod";

import type { ApiResponseBody } from "@/lib/api/api-type-helper";

import type { OperationEventsResponse } from "./-query/type";

type OperationEventStatus = OperationEventsResponse["items"][number]["status"];
type OperationForceCode = NonNullable<
  ApiResponseBody<
    "/v2/boe/events/instances/{eventInstanceId}/steps",
    "get"
  >["steps"][number]["force"]
>;

export const Columns = {
  EVENT: "EVENT",
  ANCHOR_DATE: "ANCHOR_DATE",
  STEP_PROGRESS: "STEP_PROGRESS",
  TASK_PROGRESS: "TASK_PROGRESS",
  STATUS: "STATUS",
  ACTIONS: "ACTIONS",
} as const;

export type Columns = (typeof Columns)[keyof typeof Columns];

export const EventStatusValues: Record<
  OperationEventStatus,
  OperationEventStatus
> = {
  InProgress: "InProgress",
  Completed: "Completed",
  Aborted: "Aborted",
};

export const ForceValues: Record<OperationForceCode, OperationForceCode> = {
  HRF_LABOR_CORE: "HRF_LABOR_CORE",
  HRF_CONTRACTOR_CORE: "HRF_CONTRACTOR_CORE",
  IT_OPERATION_CORE: "IT_OPERATION_CORE",
  GA_OPERATION_CORE: "GA_OPERATION_CORE",
};

export const SearchSchema = z.object({
  pageIndex: z.number().nonnegative().default(0),
  pageSize: z.number().min(1).max(100).default(20),
  status: z.nativeEnum(EventStatusValues).optional(),
  patternId: z.string().min(1).optional(),
  eventTypeId: z.string().min(1).optional(),
});
